// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3Q2VV","title":"styles__title___3biLr","empty-post":"styles__empty-post___o2ipK","main-text":"styles__main-text___1dfhl"};